import api from './api';

export const notificationService = {
  // Get user notifications
  getList: (params = {}) => api.get('/notifications', { params }),

  // Mark notification as read
  markAsRead: (notificationId) => api.put(`/notifications/${notificationId}/read`),

  // Mark all notifications as read
  markAllAsRead: () => api.put('/notifications/read-all'),

  // Delete notification
  delete: (notificationId) => api.delete(`/notifications/${notificationId}`),
};
